import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../../styles/chat/home.css';
import * as globals from './../../components/GlobalScripts.js';
import Rating from './../rating/Rating';

const Chat_home = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const [timeConversationEndRef, setTimeConversationEndRef] = useState(0);
    const [stripeChargeValue, setStripeChargeValue] = useState(0);
    const [paymentStatusProcess, setPaymentStatusProcess] = useState(0);
    const [sectionView, setSectionView] = useState(2);
    const [user, setUser] = useState([]);
    const [profesional, setProfesional] = useState([]);
    const [newChat, setNewChat] = useState("");
    const [adjunto, setAdjunto] = useState(null);
    const [messages, setMessages] = useState([]);
    const [chatsHistory, setChatsHistory] = useState([]);
    const [formDataPropuesta, setFormDataPropuesta] = useState({
        keys: '',
        sender: '',
        titulo: '',
        descripcion: '',
        precio: 0,
        cargada: false,
        estado: '',
        sender_accept: false,
        receiver_accept: false
    });
    const [formDataReview, setFormDataReview] = useState({});

    useEffect(() => {
        if (id != "view")
            get_profil();
        
        if (id == "view")
            setSectionView(1)
        else
            setSectionView(2);

        setTimeConversationEndRef(0);
    }, [location]);

    const get_profil = () => {
        globals.openViewCharge();
        axios.post(`${path_api}/default/get_profile.php`, {
            rute: globals.getRuteBackend(),
            keylogin: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setProfesional(response.data.profile);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvo el perfil",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar el perfil",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);
        }

        getMessages();
        getChatHistory();
        getProposal();
    }, [location, location.search]);

    const getProposal = () => {
        axios.post(`${path_api}/chat/get_proposal.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            key_primary: globals.get_keylogin(),
            key_secundary: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                if (response.data.proposal) {
                    setFormDataPropuesta(response.data.proposal);
                } else {
                    const cachedData = localStorage.getItem('formDataSearch');
                    const queryParams = new URLSearchParams(location.search);
                    const act = queryParams.get("action");
                    if (act == "presupuesto")
                        startChat(JSON.parse(cachedData));
                    else
                        setFormDataPropuesta({
                            keys: '',
                            sender: '',
                            titulo: '',
                            descripcion: '',
                            precio: 0,
                            cargada: false,
                            estado: '',
                            sender_accept: false,
                            receiver_accept: false
                        });
                }
            }
        }).catch(err => {
            setFormDataPropuesta({
                keys: '',
                sender: '',
                titulo: '',
                descripcion: '',
                precio: 0,
                cargada: false,
                estado: '',
                sender_accept: false,
                receiver_accept: false
            });
        });
    };

    const startChat = (temp) => {
        setFormDataPropuesta({
            keys: globals.get_keylogin() + ',' + id,
            sender: id,
            titulo: temp?.titulo,
            descripcion: temp?.descripcion_servicio,
            precio: 100,
            cargada: true,
            estado: "por_publicar",
            sender_accept: true,
            receiver_accept: false
        });
    };

    const handleSubmit_Propuesta = async (e) => {
        e.preventDefault();
        globals.openViewCharge();
        axios.post(`${path_api}/chat/proposal.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            proposal: formDataPropuesta,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "La propuesta se envió correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                setFormDataPropuesta(prev => ({ ...prev, estado: "publicada" }));
                let msg = `Mensaje automatico:
                    Propuesta creada.
                    Si no se actualiza tu propuesta recarga la página.

                    En espera de que el profesional acepte la propuesta.

                    Titulo:
                    ${formDataPropuesta.titulo}

                    Descripcion:
                    ${formDataPropuesta.descripcion}

                    Precio:
                    $${formDataPropuesta.precio} MXN`;
                newMsgSystem(msg);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo enviar la propuesta.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al enviar la propuesta.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const newMsgSystem = async (msg, refresh) => {
        const formData = new FormData();
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());
        formData.append('keys', user?.keylogin + ',' + id);
        formData.append('msg', msg);
        formData.append('sender', 'System');

        globals.openViewCharge();
        axios.post(`${path_api}/chat/send_message.php`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data.mensaje === 'success') {
                getMessages();
                getChatHistory();
                if (refresh)
                    navigate(`/chat/${profesional.keylogin}/`)
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo enviar el mensaje",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al enviar el mensaje",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDataPropuesta({ ...formDataPropuesta, [name]: value });
    };

    const getMessages = () => {
        axios.post(`${path_api}/chat/get_messages.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            key_primary: globals.get_keylogin(),
            key_secundary: id
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setMessages(response.data.messages);
            }
        }).catch(err => {
            console.error(err);
        });
    };

    const getChatHistory = () => {
        axios.post(`${path_api}/chat/get_conversations.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setChatsHistory(response.data.conversations);
            }
        }).catch(err => {
            console.error(err);
        });
    };

    useEffect(() => {
        let intervalId = setInterval(() => {
            getMessages();
            getChatHistory();
        }, 5000);
        return () => clearInterval(intervalId);
    }, [id, user]);

    const handleSubmit_Chat = async (e) => {
        e.preventDefault();
        const maxSize = 2 * 1024 * 1024;
        const formData = new FormData();
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());
        formData.append('keys', user?.keylogin + ',' + id);
        formData.append('msg', newChat);
        formData.append('sender', user?.keylogin);

        if (adjunto) {
            if (adjunto.size > maxSize) {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: "El adjunto excede el tamaño máximo de 2MB",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                return;
            }
            formData.append('adjunto', adjunto);
        }

        globals.openViewCharge();
        axios.post(`${path_api}/chat/send_message.php`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setTimeConversationEndRef(0);
                setNewChat("");
                getMessages();
                getChatHistory();
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo enviar el mensaje",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al enviar el mensaje",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const conversationEndRef = useRef(null);

    useEffect(() => {
        if (timeConversationEndRef == 0 && messages.length) {
            setTimeConversationEndRef(1);
            conversationEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages]);

    const proposal_update = async (estado, sender_accept, receiver_accept, msg) => {
        globals.openViewCharge();
        axios.post(`${path_api}/chat/update_proposal.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id_proposal: formDataPropuesta.id,
            estado: estado,
            sender_accept: sender_accept,
            receiver_accept: receiver_accept
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "La propuesta se actualizo correctamente.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                setFormDataPropuesta(response.data.proposal);
                if (!msg)
                    msg = `Mensaje automatico:
                        Si no se actualiza tu propuesta recarga la página.

                        Cambio de estado de la propuesta.

                        Estado:
                        ${estado}`;
                newMsgSystem(msg, 1);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo actualizar la propuesta.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar la propuesta.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/";
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            initializeStripe();
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const initializeStripe = async () => {
        await axios
            .post(`${path_api}/get_stripe_keys.php`, {
                rute: globals.getRuteBackend()
            })
            .then((response) => {
                if (response.data.mensaje === "success") {
                    if (!window.stripe)
                        window.stripe = window.Stripe(response.data.key_public);
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Stripe",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-stripe-1'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
            });
    };

    useEffect(() => {
        if (formDataPropuesta?.estado == 'por_pagar' && formDataPropuesta?.sender == user.keylogin) {
            const queryParams = new URLSearchParams(location.search);
            const act = queryParams.get("payment_status");

            if (!act) {
                setStripeChargeValue(0);
                chargeStripe();
            } else {
                if (paymentStatusProcess)
                    return;

                setPaymentStatusProcess(1);

                if (act == 'succeeded')
                    proposal_update("pagado", formDataPropuesta.sender_accept, formDataPropuesta.receiver_accept);
                else {
                    proposal_update("por_pagar", formDataPropuesta.sender_accept, formDataPropuesta.receiver_accept, `Mensaje automatico:
                        Si no se actualiza tu propuesta recarga la página.

                        El pago no obtuvo una respuesta de exito.

                        Estado del pago:
                        ${act}
                        
                        El pago seguira pendiente`);
                }
            }
        }

        let intervalId_ = setInterval(() => {
            if ((formDataPropuesta?.estado == 'por_publicar' && formDataPropuesta.sender != user?.keylogin) ||
                (formDataPropuesta?.estado == 'publicada' && formDataPropuesta.sender == user?.keylogin) ||
                (formDataPropuesta?.estado == 'por_pagar' && formDataPropuesta.sender == user?.keylogin) ||
                (formDataPropuesta?.estado == 'pagado' && formDataPropuesta.sender == user?.keylogin) ||
                formDataPropuesta?.estado == 'finalizada')
                return;

            getProposal();
        }, 5000);
        return () => clearInterval(intervalId_);
    }, [formDataPropuesta]);

    const chargeStripe = async () => {
        globals.openViewCharge();
        await axios
            .post(`${path_api}/stripe/create_project.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                proposal: formDataPropuesta
            })
            .then(async (response) => {
                if (response.data.mensaje === "success") {
                    const intervalId = setInterval(async () => {
                        const paymentElement = document.querySelector('#payment-element');
                        if (paymentElement) {
                            setStripeChargeValue(1);
                            window.clientSecret = response.data.response.client_secret;

                            window.elements = window.stripe.elements({ clientSecret: window.clientSecret });

                            await window.elements.create("payment", { layout: "tabs" }).mount("#payment-element");

                            globals.closeViewCharge();

                            clearInterval(intervalId);
                        }
                    }, 1000);
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Stripe",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                    globals.closeViewCharge();
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-stripe-2'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
                globals.closeViewCharge();
            });
    };

    const handleSubmit_Stripe = async (e) => {
        e.preventDefault();
        globals.openViewCharge();

        let redirect = `${globals.getRuteHost()}/chat/${profesional.keylogin}/`;
        let url = `https://donhonesto.zadrig.com/backend/stripe/confirm_project/?redirect=${encodeURIComponent(redirect)}&proposal_id=${formDataPropuesta.id}`;
        await window.stripe.confirmPayment({
            elements: window.elements,
            confirmParams: {
                return_url: url,
            },
        }).then(function (result) {
            if (result.error) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: result.error.message, effect: "opacidad 2s, desplazamiento 2s", time_life: 6000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "Error interno, intenta más tarde", effect: "opacidad 2s, desplazamiento 2s", time_life: 8000 });
            }
            globals.closeViewCharge();
        });
    };

    const handleSubmit_Review = async (e) => {
        e.preventDefault();
        let review = {
            id_proposal: formDataPropuesta.id,
            sender: formDataPropuesta.sender == user.keylogin ? user.keylogin : id,
            recieved: formDataPropuesta.sender != user.keylogin ? user.keylogin : id,
            type: formDataPropuesta.sender == user.keylogin ? 'cliente' : 'profesional',
            rating: formDataReview.rating,
            description: formDataReview.descripcion,
            sender_review: formDataPropuesta.sender == user.keylogin ? 1 : 0,
            receiver_review: formDataPropuesta.sender != user.keylogin ? 1 : 0,
        }
        globals.openViewCharge();
        axios.post(`${path_api}/chat/new-review.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            review: review,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "La calificación se proceso con exito.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                setFormDataPropuesta(response.data.proposal);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se crear la calificación.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al crear la calificación.",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange_review = (e) => {
        const { name, value } = e.target;
        setFormDataReview({ ...formDataReview, [name]: value });
    };

    useEffect(() => {

        document.querySelector('.container-chat .left-side')?.classList.add('mobile-hidden');
        document.querySelector('.container-chat .middle-side')?.classList.add('mobile-hidden');
        document.querySelector('.container-chat .right-side')?.classList.add('mobile-hidden');

        if (sectionView == 1)
            document.querySelector('.container-chat .left-side')?.classList.remove('mobile-hidden');
        if (sectionView == 2)
            document.querySelector('.container-chat .middle-side')?.classList.remove('mobile-hidden');
        if (sectionView == 3)
            document.querySelector('.container-chat .right-side')?.classList.remove('mobile-hidden');
    }, [sectionView]);

    return (
        <>
            <div className='container-chat page-home'>
                <div className='left-side mobile-hidden'>
                    <h5>Aquí cargarán tus conversaciones</h5>
                    <div className="chats-history">
                        {chatsHistory && chatsHistory.length > 0 ? (
                            chatsHistory.map((chat, i) => (
                                <Link key={i} className={`profile-name ${chat.last_sender === user?.keylogin ? 'sent' : 'received'}`} to={`/chat/${chat.other_key}/`}>
                                    <img src={path_api + chat?.img_profile}></img>
                                    <div className='flex-column gap-5'>
                                        <h5>{chat?.nombre}</h5>
                                        <p>Mensaje: {chat?.msg}</p>
                                    </div>
                                </Link>
                            ))
                        ) : (
                            <p>No hay conversaciones.</p>
                        )}
                    </div>
                </div>
                {id != "view" && (
                    <div className="middle-side">
                        <button className='view-chats-history' onClick={() => setSectionView(1)}>
                            Conversaciones
                        </button>
                        <div className="conversation">
                            {messages.map((msg, i) => (
                                <div key={i} className={`chat-message ${msg.sender === user?.keylogin ? 'sent' : msg.sender === id ? 'received' : 'system'}`}>
                                    <span>
                                        <p>{msg.msg}</p>
                                    </span>
                                </div>
                            ))}
                            <div ref={conversationEndRef} />
                            <button className='view-proposal' onClick={() => setSectionView(3)}>
                                Ver propuesta
                            </button>
                        </div>
                        <form onSubmit={handleSubmit_Chat}>
                            <div className="form-group">
                                <textarea
                                    type="text"
                                    id="msg"
                                    name="msg"
                                    value={newChat}
                                    onChange={(e) => setNewChat(e.target.value)}
                                    className="input-primary"
                                    placeholder="¿Necesitas decir algo?..."
                                    rows="3"
                                />

                            </div>
                            <button type="submit">
                                <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M99.775 4.2875C100.002 3.7196 100.058 3.09747 99.935 2.49825C99.8121 1.89902 99.516 1.34905 99.0835 0.916504C98.651 0.483964 98.101 0.18788 97.5018 0.064958C96.9025 -0.0579636 96.2804 -0.00231669 95.7125 0.225L4.79375 36.5937H4.7875L1.9625 37.7187C1.42744 37.9322 0.961784 38.2894 0.616973 38.7508C0.272161 39.2123 0.0616124 39.7601 0.00858403 40.3337C-0.0444443 40.9073 0.0621115 41.4844 0.316481 42.0013C0.570851 42.5181 0.963135 42.9546 1.45 43.2625L4.0125 44.8875L4.01875 44.9L35.2375 64.7625L55.1 95.9813L55.1125 95.9938L56.7375 98.5563C57.0464 99.0412 57.4831 99.4316 57.9996 99.6844C58.5161 99.9371 59.0923 100.042 59.6648 99.9889C60.2373 99.9352 60.7839 99.7247 61.2444 99.3804C61.7049 99.0361 62.0616 98.5714 62.275 98.0375L99.775 4.2875ZM88.3187 16.1L41.4812 62.9375L40.1375 60.825C39.8913 60.4373 39.5627 60.1087 39.175 59.8625L37.0625 58.5188L83.9 11.6812L91.2625 8.7375L88.3187 16.1Z" fill="black" />
                                    </g>
                                </svg>

                            </button>
                        </form>
                    </div>
                )}
                {id != "view" && (
                    <div className="right-side mobile-hidden">
                        <div className='flex-column gap-20'>
                            <div className="profile-name">
                                <img src={path_api + profesional?.img_profile}></img>
                                <div className='flex-column gap-5'>
                                    <h5>{profesional?.account?.nombre + ' ' + profesional?.account?.apellidos}</h5>
                                    {profesional?.reviews?.reviews_sender !== null && formDataPropuesta?.cargada && formDataPropuesta.sender != user?.keylogin && (
                                        <p>Calificación como cliente</p>
                                    )}
                                    {profesional?.reviews?.reviews_sender !== null && formDataPropuesta?.cargada && formDataPropuesta.sender != user?.keylogin && (
                                        <Rating rating={profesional?.reviews?.average_rating_sender} size={20} />
                                    )}
                                    {!profesional?.reviews?.reviews_sender && formDataPropuesta?.cargada && formDataPropuesta.sender != user?.keylogin && (
                                        <div className="flex-column">
                                            <Rating rating={0} size={20} />
                                            <p>Sin evaluaciones como cliente</p>
                                        </div>
                                    )}
                                    {profesional?.reviews?.reviews_recieved !== null && formDataPropuesta?.cargada && formDataPropuesta.sender == user?.keylogin && (
                                        <p>Calificación como profesional</p>
                                    )}
                                    {profesional?.reviews?.reviews_recieved !== null && formDataPropuesta?.cargada && formDataPropuesta.sender == user?.keylogin && (
                                        <Rating rating={profesional?.reviews?.average_rating_recieved} size={20} />
                                    )}
                                    {!profesional?.reviews?.reviews_recieved && formDataPropuesta?.cargada && formDataPropuesta.sender == user?.keylogin && (
                                        <div className="flex-column">
                                            <Rating rating={0} size={20} />
                                            <p>Sin evaluaciones como profesional</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <button className='view-chat' onClick={() => setSectionView(2)}>
                                Volver al chat
                            </button>
                        </div>
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'por_publicar' && (
                            <form onSubmit={handleSubmit_Propuesta}>
                                <div className="form-group">
                                    <label htmlFor="titulo">Titulo</label>
                                    <input
                                        type="text"
                                        id="titulo"
                                        name="titulo"
                                        value={formDataPropuesta.titulo}
                                        onChange={handleChange}
                                        className="input-primary"
                                        placeholder="Ej. Creación de app"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="descripcion">Descripción de servicio</label>
                                    <textarea
                                        type="text"
                                        id="descripcion"
                                        name="descripcion"
                                        value={formDataPropuesta.descripcion}
                                        onChange={handleChange}
                                        className="input-primary"
                                        placeholder="Ej. Necesito una app para mi restaurante..."
                                        rows="3"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="precio">El cliente pagará por el servicio (MXN)</label>
                                    <input
                                        type="number"
                                        id="precio"
                                        name="precio"
                                        value={formDataPropuesta.precio}
                                        onChange={handleChange}
                                        className="input-primary"
                                        placeholder="Minimo 100"
                                        required
                                        style={{ maxWidth: "150px" }}
                                        min="100"
                                        onKeyDown={(e) => {
                                            const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                            if (allowedKeys.includes(e.key)) return;
                                            if (!/^\d$/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <p>Recibirás: {(formDataPropuesta.precio - (formDataPropuesta.precio * 0.05 + 3)).toFixed(2)} MXN</p>
                                </div>
                                <button className='button-primary' type="submit">Crear propuesta</button>
                            </form>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'publicada' && formDataPropuesta.sender == user?.keylogin && (
                            <div className="wait-response">
                                <p className='text-green'>El profesional recibirá el pago hasta finalizar el proyecto.</p>
                                <p>Esperando a que aceptes la propuesta</p>
                                <p>Titulo: {formDataPropuesta.titulo}</p>
                                <p>Descripcion: {formDataPropuesta.descripcion}</p>
                                <p>Pagarás: {formDataPropuesta.precio} MXN</p>

                                <button className='button-primary red' onClick={() => proposal_update("rechazada", 0, 0)}>
                                    Rechazar
                                </button>
                                <button className='button-primary margin-top-15' onClick={() => proposal_update("por_pagar", 1, 1)}>
                                    Aceptar
                                </button>
                            </div>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'publicada' && formDataPropuesta.sender != user?.keylogin && (
                            <div className="wait-response">
                                <p>Esperando que la otra parte acepte la propuesta</p>
                                <p>Titulo: {formDataPropuesta.titulo}</p>
                                <p>Descripcion: {formDataPropuesta.descripcion}</p>
                                <p>Recibirás: {(formDataPropuesta.precio - (formDataPropuesta.precio * 0.05 + 3)).toFixed(2)} MXN</p>
                            </div>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'por_pagar' && formDataPropuesta.sender == user?.keylogin && (
                            <form onSubmit={handleSubmit_Stripe} className="flex-column gap-20">
                                <h4>Pago de proyecto</h4>
                                <p className='text-green'>El profesional recibirá el pago hasta finalizar el proyecto.</p>
                                <p>Pagarás: ${formDataPropuesta.precio} MXN</p>
                                <div id="stripe-container">
                                    <div id="payment-element"></div>
                                </div>
                                {!!stripeChargeValue && (
                                    <div className='flex-column gap-10'>
                                        <button type="submit" className="button-primary green">Finalizar pago</button>                                    
                                        <p className='text-green'>Al pagar en la plataforma, la calidad del servicio esta garantizada.</p>
                                    </div>
                                )}
                                {!stripeChargeValue && (
                                    <p>Esperando a que cargue la pasarela de pago.</p>
                                )}
                            </form>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'por_pagar' && formDataPropuesta.sender != user?.keylogin && (
                            <div className="wait-response">
                                <p>Esperando que el cliente pague el proyecto</p>
                                <p>Titulo: {formDataPropuesta.titulo}</p>
                                <p>Descripcion: {formDataPropuesta.descripcion}</p>
                                <p>Recibirás: {(formDataPropuesta.precio - (formDataPropuesta.precio * 0.05 + 3)).toFixed(2)} MXN</p>
                                <p>El monto se acreditará como saldo en tu cuenta al finalizar el proyecto.</p>
                            </div>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'pagado' && formDataPropuesta.sender == user?.keylogin && (
                            <div className="wait-response">
                                <p className='text-green'>El profesional recibirá el pago hasta finalizar el proyecto.</p>
                                <p>Esperando a que se complete el proyecto</p>
                                <p>Una vez el profesional termine su trabajo deberás marcarlo como completado.</p>

                                <button className='button-primary margin-top-15' onClick={() => proposal_update("completado", 1, 1)}>
                                    Marcar como completado
                                </button>
                            </div>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'pagado' && formDataPropuesta.sender != user?.keylogin && (
                            <div className="wait-response">
                                <p>Esperando que el cliente marque como completado el proyecto</p>
                                <p>Recibirás: {(formDataPropuesta.precio - (formDataPropuesta.precio * 0.05 + 3)).toFixed(2)} MXN</p>
                                <p>El monto se acreditará como saldo en tu cuenta.</p>
                            </div>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender == user?.keylogin && !formDataPropuesta.sender_review && (
                            <form onSubmit={handleSubmit_Review}>
                                <h4>Esto aparecerá en el perfil del profesional</h4>
                                <div className="form-group">
                                    <label htmlFor="rating">Calificación (0-5)</label>
                                    <input
                                        type="number"
                                        id="rating"
                                        name="rating"
                                        value={formDataReview.rating}
                                        onChange={handleChange_review}
                                        className="input-primary"
                                        placeholder="0-5"
                                        required
                                        style={{ maxWidth: "100px" }}
                                        min="0"
                                        max="5"
                                        onKeyDown={(e) => {
                                            const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                            if (allowedKeys.includes(e.key)) return;
                                            if (!/^\d$/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="descripcion">Describre tu experiencia con el profesional</label>
                                    <textarea
                                        type="text"
                                        id="descripcion"
                                        name="descripcion"
                                        value={formDataReview.descripcion}
                                        onChange={handleChange_review}
                                        className="input-primary"
                                        placeholder="EJ: Muy puntual y amable."
                                        rows="3"
                                        required
                                    />
                                </div>
                                <button className='button-primary' type="submit">Enviar</button>
                            </form>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender != user?.keylogin && !formDataPropuesta.receiver_review && (
                            <form onSubmit={handleSubmit_Review}>
                                <h4>Esto aparecerá en el perfil del cliente</h4>
                                <div className="form-group">
                                    <label htmlFor="rating">Calificación (0-5)</label>
                                    <input
                                        type="number"
                                        id="rating"
                                        name="rating"
                                        value={formDataReview.rating}
                                        onChange={handleChange_review}
                                        className="input-primary"
                                        placeholder="0-5"
                                        required
                                        style={{ maxWidth: "100px" }}
                                        min="0"
                                        max="5"
                                        onKeyDown={(e) => {
                                            const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"];
                                            if (allowedKeys.includes(e.key)) return;
                                            if (!/^\d$/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="descripcion">Describre tu experiencia con el cliente</label>
                                    <textarea
                                        type="text"
                                        id="descripcion"
                                        name="descripcion"
                                        value={formDataReview.descripcion}
                                        onChange={handleChange_review}
                                        className="input-primary"
                                        placeholder="EJ: Muy puntual y amable."
                                        rows="3"
                                        required
                                    />
                                </div>
                                <button className='button-primary' type="submit">Enviar</button>
                            </form>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender == user?.keylogin && formDataPropuesta.sender_review && !formDataPropuesta.receiver_review && (
                            <div className="wait-response">
                                <p>Esperando a que el profesional te califique</p>
                            </div>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender != user?.keylogin && formDataPropuesta.receiver_review && !formDataPropuesta.sender_review && (
                            <div className="wait-response">
                                <p>Esperando a que el cliente te califique</p>
                            </div>
                        )}
                        {formDataPropuesta?.cargada && formDataPropuesta.estado == 'completado' && formDataPropuesta.sender_review && formDataPropuesta.receiver_review && (
                            <div className="wait-response">
                                <p>Finaliza el proyecto para que se libere.</p>

                                <button className='button-primary margin-top-15' onClick={() => proposal_update("finalizada", 1, 1)}>
                                    Marcar como finalizado
                                </button>
                            </div>
                        )}
                        {(!formDataPropuesta?.cargada || formDataPropuesta.estado == 'finalizada') && (
                            <div className='error'>
                                <p className='center'>
                                    No se encontró ninguna propuesta activa.
                                </p>
                                <Link to={`/chat/${profesional.keylogin}/?action=presupuesto`}>Genera una nueva propuesta</Link>
                                <p className='center margin-top-15'>
                                    Si habia una, recargue la página.<br /><br />
                                    Si el problema persiste, informe al soporte.
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default Chat_home;